import { DxMultipleComponentItemType } from '@/container';
import { TCubeDimension } from '@cubejs-client/core';

export interface CreateChartModel {
  name: string | null,
}

export interface ComboboxValue {
  id: string | number;
  value: string;
}

export interface ChartDataType {
  id: string,
  idFilial: number,
  filial: string,
  idCity: number,
  city: string,
  idProvince: number,
  province: string,
  idRegion: number,
  region: string,
  vaniCount: number,
  windowsCount: number
}

export interface ValidatedQuery {
  measures: string[],
  dimensions: string[],
  order: {
    [key: string]: string
  }
}

export interface ISortingFieldComboboxValue {
  displayValue: string,
  key: string,
  value: string
}

export enum SortingDirection {
  ASC = 'asc',
  DESC = 'desc'
}

export enum ChartType {
  PIE = 'pie',
  LINE = 'line',
  BAR = 'bar',
  TABLE = 'table',
  AREA = 'area',
  RADAR = 'radar'
}

export const TOGGLE_DONUT_EVENT = 'toggleDonut';

export interface ITreeViewItem extends DxMultipleComponentItemType {
	id: string;
	dimension: TCubeDimension;
	categoryId?: string;
	dateRange?: IDateRange;
	granularity?: IGranularity;
}

interface IDateRange {
	name: string;
	filter: string;
}

interface IGranularity {
	name?: string;
	title: string;
	byWeek: boolean;
}
